module.exports = __webpack_public_path__ + "img/Customs-clearance5.2ee67af7.png";